import { Company } from '../api/models/company';

export interface ModelStudentprofile {

  id : string,
  firstName: string,
  lastName: string,
  infix: string,
  homeAddress: {
    street: '',
    number: '',
    numberSuffix: '',
    postalCode: '',
    city: '',
    country: '',
    latitude: '',
    longitude: ''
  },
  phoneNumber: string,
  birthDate: any,
  parentEmailAddress: string,
  hasParentalConsent: boolean,
  hasMediaConsent: boolean,
  hasAcceptedGdprPolicy: boolean,
  hasDataUsageConsent: boolean,
  profileType: string,
  lookingFor: string,
  allowEmailNotifications: boolean,
  isSubscribedToNewsletter: boolean,

  // Collections
  interests: any,
  educations: any,
  languageProficiencies: any,
  workExperiences: any,
  foreignExperiences: any,
  areaOfInterests: any,

  // Dummy
  studentProfileCvs: any,
  avatarUri: string,
  profileStrength: any,
  referenceCode: string|null,
  preferredLanguage: string|null,
  blacklistedCompanies?: Array<Company> | null,
  tags?: Array<string> | null,
}

export const studentprofilePlaceholder = {
  avatarPlaceholder: '/assets/img/placeholder/image-placeholder-profile.jpg'
}
